import { useEffect, useState } from 'react';
import { CheckCircleIcon } from "@heroicons/react/20/solid";
import { checkThePassword, titlesOfPasswordsState } from 'constants/index';

const PasswordVerification = ({ password, areEqual }) => {
  const [passwordState, setPasswordState] = useState({
    isLettersNumber: false,
    isUppercase: false,
    isLowerCase: false,
    isDigit: false,
    isSymbols: false
  })

  useEffect(() => {
    const { isLettersNumber, isUppercase, isLowerCase, isDigit, isSymbols } = checkThePassword(password)
    setPasswordState({
      isLettersNumber, isUppercase, isLowerCase, isDigit, isSymbols 
    })
  }, [password])

  return (
    <ul>
      {
        Object.entries(titlesOfPasswordsState).map(([key, value]) => (
          <li
            className="flex items-center mb-1"
          >
            <span className="mr-4">
              <CheckCircleIcon className={`h-4 w-4 ${passwordState[key] ? "text-success" : "text-muted"}`} />
            </span>
            <p>{value}</p>
          </li>
        ))
      }
        <li
          className="flex items-center mb-1"
        >
        <span className="mr-4">
          <CheckCircleIcon className={`h-4 w-4 ${areEqual ? "text-success" : "text-muted"}`} />
        </span>
        <p>Passwords must match in both fields</p>
      </li>
    </ul>
  )
}

export default PasswordVerification;